<template>
  <v-card
    outlined
    :class="[
      'product-card',
      `mode-${mode}`,
      { 'rounded-0': $vuetify.breakpoint.xsOnly },
      ...promoClass
    ]"
    :id="`product-card-${product.slug}`"
    :to="{ name: 'Product', params: { slug: product.slug } }"
  >
    <div class="product" @click="$emit('selectProduct')">
      <div class="d-flex justify-end align-center w-100 top">
        <div class="product-badge" v-if="product.badge">
          {{ product.badge.label }}
        </div>
        <v-spacer />
        <ProductAcqLimit :product="product" />
        <v-tooltip left :key="heartKey">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click.stop.prevent="addToFavorites"
              @mousedown.stop
              aria-label="Aggiungi ad una lista"
              class="add-to-fav-btn"
              :class="mode === 'list' ? 'mt-3' : 'mt-0'"
            >
              <v-icon color="primary" v-if="highlight" size="20"
                >$heart1</v-icon
              >
              <v-icon v-else color="grey" size="20">$heart</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("product.addToList") }}</span>
        </v-tooltip>
      </div>
      <div class="w-100">
        <div class="d-flex body" :class="containerClass">
          <img
            :src="product.mediaURL"
            onerror="this.onerror=null;this.src='/no-icon.png'"
            class="product-img align-self-center"
            :alt="'Immagine' + product.name"
            :title="
              product.name + ' (' + product.codInt + '-' + product.codVar + ')'
            "
          />

          <div
            class="description default--text d-flex flex-column justify-left w-100 mt-3 ml-sm-0"
            :class="mode === 'grid' ? 'ml-0' : 'ml-1'"
          >
            <h2 class="name font-weight-bold">{{ product.name }}</h2>
            <span class="cod-int text-caption d-none">
              cod. {{ product.codInt }}
            </span>
            <span class="short_descr">
              {{ product.shortDescr }}
            </span>
            <span class="descr">
              {{ product.description }}
              <span
                class="weight-unit"
                v-if="
                  product.productInfos &&
                    product.productInfos.TIPOLOGIA == 'Pezzo' &&
                    product.priceUmDisplay
                "
              >
                - {{ $n(product.priceUmDisplay, "currency") }}/{{
                  product.weightUnitDisplay
                }}
              </span>
            </span>
            <span
              class="option d-flex align-center justify-space-between line-height-1"
              style="white-space: initial;text-align: left;"
              v-for="(value, label) in selectedOptions"
              :key="label"
            >
              <div>
                <i
                  >Preferenza:<b>
                    {{ value
                    }}{{
                      label === "customWeight"
                        ? " " + product.productInfos.WEIGHT_UNIT_SELLING
                        : ""
                    }}</b
                  ></i
                >
              </div>
              <SelectedOptionsMenu
                :product="product"
                :selectOptionsArray="selectOptionsArray"
                :size="'small'"
                @onOptionChanged="onOptionChanged"
              />
            </span>

            <v-spacer />
          </div>
        </div>
        <div v-if="product.available > 0" class="actions" @click.stop.prevent>
          <!--  -->
          <ProductPrice
            :mode="mode"
            v-if="product.priceDisplay"
            :product="product"
          />
          <v-spacer v-if="mode === 'list'" />
          <SelectedOptionsMenu
            v-if="quantity <= 0"
            :product="product"
            :selectOptionsArray="selectOptionsArray"
            :size="'large'"
            @onOptionChanged="onOptionChanged"
            @setSelectOptions="setSelectOptions"
          />
          <ProductQty
            :key="key"
            :selectedOptions="selectedOptions"
            :product="product"
            :item="item"
            :position="position"
          />
        </div>
        <div
          v-else
          class="actions justify-center align-center text-center text-caption error--text font-weight-bold"
        >
          {{ $t("product.notAvailable") }}
        </div>

        <!-- <div>spazio mele</div> -->
        <ProductRating
          v-if="
            $vuetify.breakpoint.mdAndUp &&
              isAuthenticated &&
              product.productInfos &&
              product.productInfos.RATE_ENABLED &&
              product.productInfos.RATE_ENABLED == 'true'
          "
          :product="product"
          :showButton="true"
        />
      </div>
    </div>
  </v-card>
</template>
<style lang="scss">
.product-card {
  &.mode-grid {
    @media #{map-get($display-breakpoints, 'xs-only')} {
      height: 280px !important;
      padding: 8px 4px !important;
      border-radius: 4px !important;
      border-top: thin solid rgba(0, 0, 0, 0.12) !important;

      .product {
        .product-badge {
          // width: 130px !important;
          width: fit-content !important;
          max-width: 130px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .body {
          flex-direction: column !important;
        }
      }
      .description {
        margin: 0 !important;
        // padding: 0 4px !important;
        padding: 0 !important;
      }

      .actions {
        height: 105px !important;
        flex-direction: column !important;

        .product-price {
          width: 100% !important;

          .warehouse-promo-price {
            .product_promo {
              .promo_header {
                width: 50% !important;
                max-width: unset !important;
              }
              .promo_body {
                width: 50% !important;
                max-width: unset !important;
              }
            }
          }
          .price {
            justify-content: flex-end !important;
            .price_block {
              .cur-price {
                font-family: "Open Sans" !important;
                text-align: left !important;
                font-size: 16px !important;
                .weight-unit {
                  font-size: 10px !important;
                }
              }
            }
          }
        }
        .qty-wrap {
          overflow: unset !important;
          .btn-add-box {
            font-family: "Open Sans";
            height: 40px !important;
          }
        }
        .qty-wrap.not-empty {
          width: 100% !important;
        }
      }
    }
  }

  .v-rating .v-icon {
    font-size: 16px;
  }

  .product-img {
    width: 170px;
    height: 170px;
  }

  .product .description .name {
    font-family: $heading-font-family;
  }

  .promo-wrapper {
    position: absolute;
    top: -1px;
    left: -1px;
    display: flex;
    flex-direction: column;
    z-index: 3;
  }

  .cart-item-info {
    margin-bottom: -21px;
  }

  .top {
    height: 21px;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    padding: 8px 12px !important;
    height: 164px;
    width: 100% !important;
    border-top: none !important;

    .product {
      margin: 0 !important;
      padding: 0 !important;
      height: 86px !important;

      .body {
        padding-top: 2px !important;
        flex-direction: column;
      }
    }

    .description {
      margin: 0 !important;
      padding: 0 0 0 12px !important;
    }

    .product-img {
      width: 70px;
      height: 70px;
    }

    .actions {
      height: 58px !important;
      padding: 0 0 2px 0 !important;
      margin: 0 !important;

      .warehouse-promo-price {
        flex-direction: column !important;

        .promo_bubble {
          position: relative !important;
          top: inherit !important;
        }

        .promo_header,
        .promo_body {
          height: 40px !important;
        }
      }

      .qty-wrap {
        &.not-empty {
          width: 156px !important;
          height: 40px !important;

          .plus {
            width: 42px !important;
            height: -webkit-fill-available !important;
            border-radius: 0 4px 4px 0 !important;
          }

          .minus {
            width: 42px !important;
            height: -webkit-fill-available !important;
            border-radius: 4px 0 0 4px !important;
          }
        }

        .plus {
          width: 60px !important;
          height: 40px !important;
          border-radius: 4px !important;
          margin: 0 !important;

          i {
            font-size: 25px !important;
          }
        }
      }
    }

    .product-price {
      width: 140px;
      text-align: center;
    }

    .name {
      max-height: 37px !important;
      line-height: 18px !important;
    }

    .product-badge {
      position: relative !important;
      top: 0px !important;
      max-height: 21px !important;
      max-width: 100% !important;
      font-size: 12px !important;
      padding: 2px 4px;
      border-radius: 3px !important;
      z-index: 4 !important;
    }
  }

  .actions {
    .selectOptions {
      margin-right: 3px;
    }
  }

  .selectOptionsMenu {
    z-index: 12;
  }
}
</style>

<script>
import ProductAcqLimit from "./ProductAcqLimit.vue";
import ProductPrice from "./ProductPrice.vue";
import ProductQty from "./ProductQty.vue";
import ProductRating from "@/components/product/ProductRating.vue";
import SelectedOptionsMenu from "@/components/product/SelectedOptionsMenu.vue";

import productMixin from "~/mixins/product";

import { mapState, mapGetters } from "vuex";

import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "ProductCard",
  props: {
    product: { type: Object, required: true },
    position: { type: Number, default: undefined },
    mode: {
      type: String,
      default: window.localStorage.getItem("ProductListMode") || "list"
    }
  },
  components: {
    ProductAcqLimit,
    ProductPrice,
    ProductQty,
    ProductRating,
    SelectedOptionsMenu
  },
  mixins: [productMixin],
  data() {
    return {
      selectOptionsArray: [],
      selectedOptions: {},
      key: 0
    };
  },
  computed: {
    ...mapGetters({
      getItem: "cart/getItem",
      isAuthenticated: "cart/isAuthenticated"
    }),
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    containerClass() {
      if (!this.$vuetify.breakpoint.xsOnly) {
        return "flex-column";
      }
      return this.mode === "list" ? "flex-row" : "flex-column";
    },
    promoProductClasses() {
      return this.product.productClasses.filter(
        pClass => pClass.productClassGroupId === 6
      );
    },
    item() {
      this.key;
      let item = this.getItem({
        product: this.product,
        ...this.selectedOptions
      });
      return item;
    },
    promoClass() {
      let productClasses = [];
      let cssClass = get(this.product, "warehousePromo.view.cssClass");
      if (cssClass) {
        productClasses.push("has-promo");
        productClasses.push(cssClass);
      }
      if (this.product.isNew) {
        productClasses.push("new-product");
      }
      if (this.product.badge) {
        productClasses.push(this.product.badge.cssClass);
      }
      return productClasses;
    }
  },
  methods: {
    giftAdded() {
      this.plus();
    },
    onOptionChanged(args) {
      let selectOption = args.selectOption;
      let option = args.option;
      this.key++;
      this.selectedOptions[selectOption.parameterName] = option.value;
    },
    async setSelectOptions() {
      await this.needLogin("selectoptionsmenu");
    },
    handleClick() {
      this.$emit("selectProduct");
    }
  },
  mounted() {
    if (this.product.selectOptions && this.product.selectOptions.length > 0) {
      this.selectOptionsArray = cloneDeep(this.product.selectOptions);
    }
  }
};
</script>
